// Index file for everything
// import { UAParser } from 'ua-parser-js'
import "./css/app.scss";
import "./js/app.js";
import "./js/region-switcher"
import './react';

import { onDOMLoad, onLoad } from "./js/utils";

import { InitCalculatorSwitches } from "./js/calculators/switchers";
import { widthControllerInit } from "./js/promotions/width_controller";
import { InitServicesPage }from "./js/pages/services";

import "./js/analytics";


onDOMLoad(() => {
    PagesInit()
})

// Pages
async function PagesInit() {
    let container = document.querySelector(".services-index") as HTMLElement;
    if (!container) return;

    InitServicesPage(container);
}

onDOMLoad(() => {
    PromotionsInit()
})

async function PromotionsInit() {
    let container = document.querySelector(".promotion") as HTMLElement;
    if (!container) return;

    widthControllerInit();
}

async function InitFaIcons() {
    let {InitIcons} = await import( /* webpackChunkName: "FaIcons" */ "./icons" );
    InitIcons();
    console.info("Icons loaded")    
}


onDOMLoad(() => {
    InitSwitchers();
})

onLoad(()=>{
    InitFaIcons();
})

async function InitSwitchers() {
    InitCalculatorSwitches();
}